import React from 'react';
import { Stack, Text } from '@moda/om';
import { PaymentSource } from '../../constants';
import { useOrderDetails } from '../OrderDetails';
import { useOrderDetailsPaymentSource } from './useOrderDetailsPaymentSource';
import {
  OrderDetailsAmazonPayButton,
  useIsAmazonPaySupported
} from './OrderDetailsAmazonPayButton';
import { OrderDetailsPayPalButton, usePayPalSupported } from './OrderDetailsPayPalButton';

import './OrderDetailsPaymentSources.scss';

export const OrderDetailsPaymentSources: React.FC = () => {
  const { orderSummary } = useOrderDetails();
  const { paymentSource } = useOrderDetailsPaymentSource();
  const isAmazonPaySupported = useIsAmazonPaySupported();
  const isPayPalSupported = usePayPalSupported();

  if (!orderSummary?.attributes.isPaymentChangeable) return null;
  if (paymentSource === PaymentSource.Amazon && !isPayPalSupported) return null;
  if (paymentSource === PaymentSource.PayPal && !isAmazonPaySupported) return null;

  return (
    <div className="OrderDetailsPaymentSources">
      <Text>You can also pay with</Text>
      <Stack space={2} direction="horizontal" alignItems="center">
        {paymentSource !== PaymentSource.PayPal && <OrderDetailsPayPalButton size="small" />}
        {paymentSource !== PaymentSource.Amazon && <OrderDetailsAmazonPayButton size="small" />}
      </Stack>
    </div>
  );
};
